import { useQuery } from '@tanstack/react-query';
import type { LifecycleConsequencesDto } from '@his/shared';
import { get } from '@/lib/api';
import { Alert, Spinner } from '@/components/ui/primitives';

export function consequenceLines(counts: LifecycleConsequencesDto): string[] {
  const lines: string[] = [];
  if (counts.admittedPatients > 0) lines.push(`${counts.admittedPatients} admitted patient${counts.admittedPatients === 1 ? '' : 's'}`);
  if (counts.appointmentsToday > 0) lines.push(`${counts.appointmentsToday} appointment${counts.appointmentsToday === 1 ? '' : 's'} today`);
  if (counts.claimsInFlight > 0) lines.push(`${counts.claimsInFlight} insurance claim${counts.claimsInFlight === 1 ? '' : 's'} not yet settled`);
  if (counts.openCashierShifts > 0) lines.push(`${counts.openCashierShifts} open cashier shift${counts.openCashierShifts === 1 ? '' : 's'}`);
  return lines;
}

export function ConsequencePreview({ tenantId }: { tenantId: string }) {
  const counts = useQuery({
    queryKey: ['tenant-consequences', tenantId],
    queryFn: () => get<LifecycleConsequencesDto>(`/platform/tenants/${tenantId}/consequences`),
    staleTime: 30_000,
  });
  if (counts.isLoading) {
    return (
      <p className="flex items-center gap-2 text-xs text-muted-foreground">
        <Spinner /> Counting what this touches…
      </p>
    );
  }
  if (!counts.data) return null;
  const lines = consequenceLines(counts.data);
  if (lines.length === 0) return <p className="text-xs text-muted-foreground">Nothing in progress right now.</p>;
  return (
    <Alert variant="warning" className="text-xs">
      In progress right now: {lines.join(', ')}.
    </Alert>
  );
}
